import "./styles.less";

import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { RightOutlined } from "@ant-design/icons";
import { useContext } from "react";
import { useEffect } from "react";
import { useRouter } from "next/router";
import { useState } from "react";

const BannerProptech = () => {
	const FIRST_DAY_PROPTECH = "Oct 17, 2021 18:00:00";
	const LAST_DAY_PROPTECH = "Nov 8, 2021 00:00:00";
	const link =
		"https://www.infocasas.com.uy/eventos/encuentra-proptech?utm_source=web&utm_medium=header_v2&utm_campaign=proptech";

	const [show, setShow] = useState(false);
	const { country_code } = useContext(ConfigStateContext);
	const { pathname, query } = useRouter();

	const showBanner = () => {
		document.body.classList.add("body-banner-proptech");
		setShow(true);
	};

	useEffect(() => {
		const now = new Date();
		const inicio = new Date(FIRST_DAY_PROPTECH);
		const fin = new Date(LAST_DAY_PROPTECH);
		if (
			country_code == "UY" &&
			(pathname.includes("searchPage") ||
				pathname.includes("home") ||
				pathname.includes("propSingle") ||
				pathname.includes("projectSingle")) &&
			((now.getTime() < fin.getTime() && now.getTime() > inicio.getTime()) ||
				typeof query.bannerproptech != "undefined")
		) {
			showBanner();
		}
	}, []);

	if (!show) return null;

	return (
		<a id="banner-proptech" href={link} target="_blank">
			<div className="contenedor">
				<img
					src="https://cdn2.infocasas.com.uy/web/616ed304bacf9_infocdn__20211018_bannergif_b.gif"
					className="banner"
				/>
				<div className="right-content">
					<div className="fecha">
						<span className="big">5 AL 7</span>
						<span className="small">DE NOVIEMBRE</span>
					</div>
					<div className="ubicacion">
						<div className="top">
							<img
								src="https://cdn2.infocasas.com.uy/web/61699cecdc7d5_infocdn__propetech_location.png"
								className="location"
							/>
							<span className="top-text">
								KIBÓN
								<br />
								AVANZA
							</span>
						</div>
						<span className="bottom">
							ENTRADA <span>LIBRE</span>
						</span>
					</div>
					<div className="btn desktop">Quiero asistir</div>
					<div className="btn mobile">
						<RightOutlined color={"#333"} />
					</div>
				</div>
			</div>
		</a>
	);
};

export { BannerProptech };
